// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"f84e3da9","60":"3d4b0171","112":"80ecfbac","178":"cab33125","186":"0c7d67af","348":"0d65be0f","440":"7d420a3f","480":"a2fdf28a","692":"473caa6e","794":"8d4c50a8","832":"140bf284","952":"98981efb","960":"dd535112"}[chunkId] + ".chunk.js";
};